import { useFrame } from '@react-three/fiber';

const ANIMATION_SPEED = 0.05;

const AnimationController = ({
  isAnimating,
  animationProgress,
  setAnimationProgress,
  maxAnimationProgress,
  setIsAnimating,
}) => {
  useFrame((_, delta) => {
    if (isAnimating && animationProgress < maxAnimationProgress) {
      const increment = delta * 100 * ANIMATION_SPEED;
      setAnimationProgress(Math.min(maxAnimationProgress, animationProgress + increment));
      if (animationProgress >= maxAnimationProgress) {
        setIsAnimating(false);
      }
    }
    if (isAnimating && animationProgress >= maxAnimationProgress) {
      setIsAnimating(false);
    }
  });

  return null;
};

export default AnimationController;
